// extracted by mini-css-extract-plugin
export default {"root":"_2k3Cz","deleteMessageWarning":"_1GTq2","infoIcon":"_2K9Lp"};